function bulletList (bullet, id) {
    let ul = document.getElementById(id);
    let resp = bullet.replaceAll('<p>', '').split('</p>');
    let bulletList = Object.values(resp);
    bulletList.forEach(element => {
        if ( element !== null && element !== '') {
            let li = document.createElement('li');
            li.setAttribute('class', 'culture-bulletList__item');
            li.innerText = element;
            ul.appendChild(li);
        }
    });
};